/* eslint-disable react-refresh/only-export-components */
import { useState } from 'react'
import { Button, TextInput } from '@mantine/core'
import { modals } from '@mantine/modals'

// Shared "rename" prompt used for boards, columns and tasks: a single text
// input pre-filled with the current value, Enter or Save commits, blank is
// rejected. The caller supplies the persistence via onSubmit.
const RenameForm = ({
  initial,
  label,
  placeholder,
  onSubmit,
}: {
  initial: string
  label: string
  placeholder?: string
  onSubmit: (value: string) => void
}) => {
  const [value, setValue] = useState(initial)
  const trimmed = value.trim()

  const submit = () => {
    if (!trimmed) return
    if (trimmed !== initial) onSubmit(trimmed)
    modals.closeAll()
  }

  return (
    <div>
      <TextInput
        data-autofocus
        label={label}
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.currentTarget.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') submit()
        }}
      />
      <div className="mt-3 flex justify-end gap-2">
        <Button variant="default" size="xs" onClick={() => modals.closeAll()}>
          Cancel
        </Button>
        <Button size="xs" disabled={!trimmed} onClick={submit}>
          Save
        </Button>
      </div>
    </div>
  )
}

export const openRenameModal = (opts: {
  title: string
  label: string
  initial: string
  placeholder?: string
  onSubmit: (value: string) => void
}) => {
  modals.open({
    title: opts.title,
    children: (
      <RenameForm
        initial={opts.initial}
        label={opts.label}
        placeholder={opts.placeholder}
        onSubmit={opts.onSubmit}
      />
    ),
  })
}
